/**
 * @file src/components/UserTable/UserTableStyles.tsx
 * @exports NameBase, AvatarWrapper
 * @summary styled-components for NameCell component
 */

import { styled } from "styled-components";

export const NameBase = styled.div`
  align-items: center;
  display: flex;
  gap: 20px;
  padding: 8px 0;
`;
export const AvatarWrapper = styled.div`
  flex-shrink: 0
`;
